import { render } from "./BasicResources.vue?vue&type=template&id=8d5e8dde&scoped=true"
import script from "./BasicResources.vue?vue&type=script&lang=js"
export * from "./BasicResources.vue?vue&type=script&lang=js"

import "./BasicResources.vue?vue&type=style&index=0&id=8d5e8dde&lang=scss&scoped=true"

import exportComponent from "E:\\xlckj\\大屏\\monitor\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d5e8dde"]])

export default __exports__